import { create } from 'zustand';

const useOrderStore = create((set, get) => ({
  orders: [],
  lastUpdate: null,
  lastSyncedAt: null, // 마지막 폴링 성공 시각 (헤더 '마지막 동기화')
  isLoading: false,

  setOrders: (newOrders) => {
    const { orders: currentOrders } = get();
    set({ lastSyncedAt: new Date() });

    // 변경 없으면 orders 갱신 안 함 (깜빡임 방지)
    // 모든 필드를 비교하여 medications 등 변경도 감지
    if (JSON.stringify(newOrders) === JSON.stringify(currentOrders)) return;

    set({ orders: newOrders, lastUpdate: new Date() });
  },
  setLoading: (isLoading) => set({ isLoading }),
}));

export default useOrderStore;
